import React from "react"

import { makeMessages } from "../../utils/makeMessages";
import { useHandleDialogOpen } from "../Dialogs"
import { Anchor } from "../Link";



export interface GdprLinkProps {
	children: React.ReactNode,
}


export const GdprAnchor = (props: GdprLinkProps) => {
	const { children } = props;
	
	const { href } = useMessages();
	const handleClick = useHandleDialogOpen("gdpr");

	return (
		<Anchor to={href} onClick={handleClick}>{children}</Anchor>
	);
}

const useMessages = makeMessages({
	href: {
		sk: '/ochrana-osobnych-udajov/',
		en: '/en/privacy-policy/'
	}
})
